import React, { Component } from "react";

import { APIHandler, BookingForm, StorageHandler, RewardMenu } from "C4";
import { storageKeys, baseAppId } from "settings";
import { Redirect } from "react-router-dom";

import { ToastContainer, toast, cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const checkInputValidityFields = () => {
  const inputs = document.getElementsByTagName("input");
  const inputArray = [];
  const selects = document.getElementsByTagName("select");
  const selectArray = Array.from(selects);
  Array.from(inputs).forEach((input) => {
    if (!input.name.includes("olark")) {
      inputArray.push(input);
    }
  });

  const emptyFields = [];
  Array.from(inputs).forEach((input) => {
    if (input.name) {
      if (input.checkValidity() === false) {
        const name = input.name
          .replace(/reg_/g, "")
          .replace(/_/g, " ")
          .replace(/([a-z])([A-Z])/g, "$1 $2")
          .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
        emptyFields.push(name);
      }
    }
  });

  selectArray.forEach((select) => {
    if (select.selectedIndex === 0) {
      const name = select.name
        .replace(/reg_/g, "")
        .replace(/_/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
      emptyFields.push(name);
    }
  });

  return emptyFields;
};

const checkInputValidity = () => {
  const inputs = document.getElementsByTagName("input");
  const inputArray = [];
  const selects = document.getElementsByTagName("select");
  const selectArray = [];

  Array.from(inputs).forEach((input) => {
    if (input.name) {
      inputArray.push(input);
    }
  });

  Array.from(selects).forEach((select) => {
    selectArray.push(select);
    // console.log('select', select, select.selectedIndex);
  });

  return (
    inputArray.every((val) => val.checkValidity() === true) &&
    selectArray.every((val) => val.selectedIndex !== 0)
  );
};

const Zoom = cssTransition({
  enter: "zoomIn",
  exit: "zoomOut",
  duration: [500, 800],
});

class BookingFormView extends Component {
  constructor() {
    super();
    this.state = {
      airline: "",
      accommodation: "",
      birthday: "",
      bookingNumber: "",
      reservationNumber: "",
      typeOfTrip: "",
      firstName: "",
      lastName: "",
      totalCost: "",
      numberOfGuests: 0,
      arrivalDate: "",
      departureDate: "",
      lengthOfStay: 0,
      originAirport: "",
      agentEmail: "",
      agentFirstName: "",
      agentLastName: "",
      agentCompany: "",
      postalCode: "",
      agentCity: "",
      agentCountry: "",
      agentId: "",
      originAirport: "",
      destinationAirport: "",
      tourOperator: "",
      wholesaler: "",
      propertyCharterCompany: "",
      files: "",
      redirect: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.handleChange3 = this.handleChange3.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);

    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    this.checkLoggedIn();
  }

  async checkLoggedIn() {
    // Not logged in from local storage
    let user = await StorageHandler.load(storageKeys.user);
    if (!user) {
      window.location.href = `${window.location.origin}/login`;
      return;
    }

    if (user && user.email) {
      this.setState({
        agentEmail: user.email,
        agentFirstName: user.first_name,
        agentLastName: user.last_name,
        agentCompany: user.agency_name,
        postalCode: user.zip_code,
        agentCity: user.city,
        agentCountry: user.country,
      });
    } else if (user) {
      user = user.response;
      this.setState({
        agentEmail: user.email,
        agentFirstName: user.first_name,
        agentLastName: user.last_name,
        agentCompany: user.agency_name,
        postalCode: user.zip_code,
        agentCity: user.city,
        agentCountry: user.country,
      });
    }
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  handleChangeFile(file) {
    console.log(file);
    this.setState({
      files: file,
    });
  }

  handleChange1(event) {
    this.setState(
      {
        departureDate: event.target.value,
      },
      () => {
        this.calculateLengthOfStayInNights();
      }
    );
  }

  handleChange2(event) {
    this.setState(
      {
        arrivalDate: event.target.value,
      },
      () => {
        this.calculateLengthOfStayInNights();
      }
    );
  }

  calculateLengthOfStayInNights() {
    const { arrivalDate, departureDate } = this.state;
    const arrival = new Date(arrivalDate);
    const departure = new Date(departureDate);
    const diffTime = Math.abs(departure - arrival);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    // If diffDays nan, then set to 0
    if (Number.isNaN(diffDays)) {
      diffDays = 0;
    }

    this.setState({
      lengthOfStay: diffDays.toString(),
    });
  }

  handleChange3(event) {
    this.setState({
      birthday: event.target.value,
    });
  }

  submitForm(event) {
    event.preventDefault();
    const submit = event.target;
    submit.disabled = true;

    if (!checkInputValidity()) {
      const invalidFields = `Please fill in all the required fields: ${checkInputValidityFields().join(
        ", "
      )}`;
      toast.error(invalidFields, {
        position: "top-center",
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      return;
    }

    // Create object to send to API
    const reward = {
      tourOperator: this.state.tourOperator,
      wholesaler: this.state.wholesaler,
      lastName: this.state.lastName,
      bookingNumber: this.state.bookingNumber,
      reservationNumber: this.state.reservationNumber,
      typeOfTrip: this.state.typeOfTrip,
      arrivalDate: this.state.arrivalDate,
      departureDate: this.state.departureDate,
      lengthOfStay: this.state.lengthOfStay,
      totalCost: this.state.totalCost,
      numberOfGuests: this.state.numberOfGuests,
      accommodationName: this.state.accommodation,
      airline: this.state.airline,
      originAirport: this.state.originAirport,
      destinationAirport: this.state.destinationAirport,
      files: this.state.files,
      agentEmail: this.state.agentEmail,
      agentFirstName: this.state.agentFirstName,
      agentLastName: this.state.agentLastName,
      propertyCharterCompany: this.state.propertyCharterCompany,
      appId: baseAppId,
    };

    APIHandler.addReward(reward).then((res) => {
      if (res.result === "failed") {
        toast.error("Something went wrong, please try again.", {
          position: "top-center",
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
        });
        submit.disabled = false;
      } else if (res.message === "The given data was invalid.") {
        toast.error("Something went wrong, please try again.", {
          position: "top-center",
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
        });
        submit.disabled = false;
      } else if (res.result === "success") {
        const params = new URLSearchParams(window.location.search);
        if (params.get("mobile")) {
          this.setState({ redirect: "/main/rewards/thank-you?mobile=true" });
        } else {
          this.setState({ redirect: "/main/rewards/thank-you" });
        }
      } else {
        toast.error(
          "Please check your (company) Firewall and/or any other restrictions. " +
            res.response,
          {
            position: "top-center",
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
        submit.disabled = false;
      }
    });
  }

  render() {
    const {
      accommodation,
      birthday,
      bookingNumber,
      reservationNumber,
      typeOfTrip,
      firstName,
      lastName,
      totalCost,
      numberOfGuests,
      arrivalDate,
      originAirport,
      departureDate,
      tourOperator,
      wholesaler,
      destinationAirport,
      lengthOfStay,
      agentEmail,
      agentFirstName,
      agentLastName,
      agentCompany,
      redirect,
      postalCode,
      agentCity,
      agentCountry,
      agentId,
      propertyCharterCompany,
      files,
    } = this.state;

    const params = new URLSearchParams(window.location.search);
    let mobile = false;
    if (params.get("mobile")) {
      mobile = true;
    }

    return (
      <React.Fragment>
        <RewardMenu />

        <BookingForm
          submitForm={this.submitForm}
          handleChange={this.handleChange}
          handleChange1={this.handleChange1}
          handleChange2={this.handleChange2}
          handleChange3={this.handleChange3}
          handleChangeFile={this.handleChangeFile}
          birthday={birthday}
          typeOfTrip={typeOfTrip}
          firstName={firstName}
          lastName={lastName}
          accommodation={accommodation}
          originAirport={originAirport}
          totalCost={totalCost}
          numberOfGuests={numberOfGuests}
          destinationAirport={destinationAirport}
          reservationNumber={reservationNumber}
          arrivalDate={arrivalDate}
          departureDate={departureDate}
          tourOperator={tourOperator}
          wholesaler={wholesaler}
          lengthOfStay={lengthOfStay}
          agentEmail={agentEmail}
          agentFirstName={agentFirstName}
          agentLastName={agentLastName}
          agentCompany={agentCompany}
          postalCode={postalCode}
          agentCity={agentCity}
          agentCountry={agentCountry}
          agentId={agentId}
          propertyCharterCompany={propertyCharterCompany}
          files={files}
          bookingNumber={bookingNumber}
        />
        <ToastContainer draggablePercent={70} />
        {redirect && <Redirect to={redirect} />}
        {mobile && (
          <style>
            {
              "\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }"
            }
          </style>
        )}
      </React.Fragment>
    );
  }
}

export default BookingFormView;
